import React from "react";
import { ReportName } from "types/gql-types";
import { ReportTable } from "./report-table";

export const ApplicationFraud: React.FC = () => (
  <ReportTable reportName={ReportName.INTEREST_DATE_MISMATCH} includeTitle />
);
